// @ts-nocheck
import * as Amplify from '@aws-amplify/api'
import { Auth } from 'aws-amplify'
import {mapStoreDataToAssistantFields} from "./passport.utils";  // Import the Auth module from Amplify

export const executeSecure = async ({ statement, name }, variables) => {
  try {
    // Retrieve the current user's session to get the Cognito JWT token
    const session = await Auth.currentSession()
    const token = session.getIdToken().getJwtToken() // Get the JWT token

    // Prepare the operation and include the Cognito token in the headers
    const operation = Amplify.graphqlOperation(statement, variables)

    const { data } = await Amplify.API.graphql({
      ...operation,
      authMode: 'AMAZON_COGNITO_USER_POOLS',  // Use Cognito User Pools as the auth mode
      headers: {
        Authorization: token,  // Attach the Cognito token to the request headers
      },
    })

    // Return the requested data
    return data[name]
  } catch (error) {
    console.error('Error executing GraphQL request:', error)
    throw error
  }
}

export const execute = async ({ statement, name }, variables) => {
  const operation = Amplify.graphqlOperation(statement, variables)
  const { data } = await Amplify.API.graphql({
    ...operation,
    authMode: 'API_KEY',
  })
  return data[name]
}
